import { Suspense } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import RootUserLayout from "../layout";
import { useDashboardData } from "../service/dashboard";
import { GrowthChart } from "./components/charts/growth-chart";
import { ResponsiblePersonsChart } from "./components/charts/responsible-persons-chart";
import { StatusDistributionChart } from "./components/charts/status-distribution-chart";
import { StatusTrendsChart } from "./components/charts/status-trends-chart";
import { TOP_NAV } from "./constants";

export default function Analytics() {
  return (
    <RootUserLayout pageTitle="Analytics Dashboard" topNav={TOP_NAV}>
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Analytics..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <AnalyticsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}

function AnalyticsContent() {
  const { monthlyTrendData, statusDistribution, topResponsiblePersons } =
    useDashboardData();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Growth Trajectory</CardTitle>
            <CardDescription>
              Cumulative organization growth over time
            </CardDescription>
          </CardHeader>
          <CardContent>
            <GrowthChart data={monthlyTrendData} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Status Distribution Trends</CardTitle>
            <CardDescription>
              Monthly organization status breakdown
            </CardDescription>
          </CardHeader>
          <CardContent>
            <StatusTrendsChart data={monthlyTrendData} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Top Responsible Persons</CardTitle>
            <CardDescription>
              Organizations per responsible person
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ResponsiblePersonsChart data={topResponsiblePersons} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Status Distribution</CardTitle>
            <CardDescription>
              Current status breakdown with percentages
            </CardDescription>
          </CardHeader>
          <CardContent>
            <StatusDistributionChart data={statusDistribution} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
